<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="850px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.editForm.cancel()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <EditForm
      ref="editForm"
      :shippingMarkCode="shippingMarkCode"
      :disabled="disabled"
      @reload="$emit('reload')"
      @close="close"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.editForm.cancel()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="$refs.editForm.save()"
        v-if="!disabled"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    shippingMarkCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
